import React from 'react';
import { Row, Col, PageHeader } from 'antd';
import './style.less';
import { GlobalResources } from './resources';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from './pages/Home';
import SearchDomain from './pages/SearchDoamin';
import Checkout from './pages/Checkout';
import { StoreProvider } from './store';
import Cart from './components/Cart';

const { APP_TITLE, APP_SUBTITLE } = GlobalResources;
const headerTitle = (
    <a href="https://hepnox.com/" target="_self">
        {APP_TITLE}
    </a>
);
function App() {
    return (
        <StoreProvider>
            <Router>
                <Cart />
                <Row>
                    <Col span={22} offset={1}>
                        <PageHeader className="page-header shadow" title={headerTitle} subTitle={APP_SUBTITLE} />{' '}
                    </Col>
                </Row>
                <Switch>
                    <Route exact path="/">
                        <Home />
                    </Route>
                    <Route path="/domains/:name">
                        <SearchDomain />
                    </Route>
                    <Route path="/checkout">
                        <Checkout />
                    </Route>
                </Switch>
            </Router>
        </StoreProvider>
    );
}

export default App;

